exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".riskQuestForm {\n  font-weight: bold;\n  border-radius: 1px solid var(--dimGray); }\n  .riskQuestForm__heading, .riskQuestForm__labels, .riskQuestForm__inputs {\n    padding: 10px 0; }\n  .riskQuestForm__heading {\n    padding: 10px 0;\n    background-color: #dbe3f0; }\n  .riskQuestForm__labels {\n    padding: 10px 0;\n    background-color: #ededef; }\n  .riskQuestForm__inputs > div {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-pack: center;\n    justify-content: center; }\n  .riskQuestForm input,\n  .riskQuestForm select {\n    width: 180px;\n    padding: 5px; }\n  @media (max-width: 768px) {\n    .riskQuestForm .mb-2 {\n      margin-bottom: 10px; } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/pages/Create_portfolio_by_Advisor/model_portfolio/riskQuestionnaire/Form/Form.style.scss
// module id = 1651
// module chunks = 0